import React from 'react'

const OurMission = ({ data }) => {
    return (
        <div className='ourMission'>
            <div className='imageDiv' style={{ background: `url(${data?.img})` }} data-aos="slide-right"></div>
            <div className='textDiv' data-aos="slide-left">
                <div className='innerText'>
                    <h1>{data?.head}</h1>
                    <p>{data?.des}</p>
                    <p>{data?.des2}</p>
                </div>
            </div>
        </div>
    )
}

export default OurMission